import React, { useState } from 'react';

import cx from 'classnames';
import { isNil } from 'ramda';

import Icon from 'components/shared/Icon';
import FullScreen from 'components/shared/Icon/icons/FullScreen';
import Left from 'components/shared/Icon/icons/Left';
import Right from 'components/shared/Icon/icons/Right';
import Modal from 'components/shared/Modal';
import parseVideoUrl from 'utils/parseVideoUrl';

import s from './index.module.css';

const components = {
  media: ({ data, slide, props }) => <img {...props} src={data.url} className={s.img} alt={`Slide #${slide}`} />,
  video: ({ data, props }) => {
    const parsedUrl = parseVideoUrl(data.link);

    if (isNil(parsedUrl)) {
      return <div className={s.noDataContainer}>{`Unable to play video URL: "${data.link}"`}</div>;
    }

    return (
      <iframe
        {...props}
        className={s.iframe}
        src={parsedUrl}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    );
  },
  noData: () => <div className={s.noDataContainer}>No Data</div>,
};

const Slider = ({ images = [], videos = [], noFullScreen, initialSlide = 0 }) => {
  const [fullScreen, setFullScreen] = useState(false);
  const [slide, setSlide] = useState(initialSlide);
  const list = [...images, ...videos];
  const current = list[slide];
  const Component = components[current?.type || 'noData'];

  const onLeft = () => setSlide(slide > 0 ? slide - 1 : slide);
  const onRight = () => setSlide(slide < list.length - 1 ? slide + 1 : slide);

  return (
    <div className={cx(s.slider, { [s.inner]: !noFullScreen })}>
      <Component data={current} slide={slide} />
      <div className={s.points}>
        {new Array(list.length).fill(null).map((_, i) => {
          return <div key={i} className={s.point} />;
        })}
      </div>
      <div className={cx(s.arrow, s.right, { [s.hide]: slide + 1 >= list.length })} onClick={onRight}>
        <Icon component={Right} height="1rem" fill="#DADADA" />
      </div>
      <div className={cx(s.arrow, s.left, { [s.hide]: slide === 0 })} onClick={onLeft}>
        <Icon component={Left} stroke="#3F3C43" height="1rem" fill="#DADADA" />
      </div>
      {!noFullScreen && (
        <>
          <div className={s.fullScreen} onClick={() => setFullScreen(true)}>
            <Icon component={FullScreen} />
          </div>
          <Modal isOpen={fullScreen} toClose={() => setFullScreen(false)}>
            {fullScreen && (
              <div className={s.full}>
                <Slider images={images} videos={videos} initialSlide={slide} noFullScreen />
              </div>
            )}
          </Modal>
        </>
      )}
    </div>
  );
};

export default Slider;
